module.exports = __webpack_public_path__ + "media/assets/doc-93b7a3ec28b9be68c132f073c23056fd98cb96d8b7b83919fb581841e451c2c1.svg";